<div class="agent-shell">
  @if (isDuplicateWindow()) {
    <div class="agent-shell__duplicate-overlay" role="alertdialog" aria-modal="true"
         aria-label="Duplicate EventQ window">
      <div class="agent-shell__duplicate-card">
        <img [src]="'/assets/login/ecam-eventq-logo.svg' | prefixUrl" alt="ECAM EventQ"
             class="agent-shell__duplicate-logo" />
        <h2 class="agent-shell__duplicate-title">EventQ is already open</h2>
        <p class="agent-shell__duplicate-body">
          Only one EventQ window can be active at a time within the same browser profile.
          Please close this window and use the existing one.
        </p>
      </div>
    </div>
  }
  <header
    class="agent-shell__header"
    [class.agent-shell__header--expanded]="chromeCompact()"
    [attr.inert]="browserTabs.claimInteractionLocked() ? '' : null"
  >
    @if (!chromeCompact()) {
      <div class="agent-shell__logo">
        <img [src]="'/assets/login/ecam-eventq-logo.svg' | prefixUrl" alt="ECAM EventQ" />
      </div>
    }
    <div class="agent-shell__tabs">
      <eventq-browser-tab-bar
        [tabs]="displayTabs()"
        [activeTabId]="browserTabs.activeTabId()"
        [expanded]="chromeCompact()"
        [popoutMode]="browserTabs.isPopoutWindow()"
        [expandEnabled]="tabPopoutEnabled"
        [closeableTabIds]="closeableTabIds()"
        [addDisabled]="!canAddTab()"
        (tabSelect)="onTabSelect($event)"
        (tabAdd)="onTabAdd()"
        (tabExpand)="onTabExpand()"
        (tabClose)="onTabClose($event)"
      />
    </div>
    @if (!chromeCompact()) {
      @if (showAutoProcess()) {
        <div class="agent-shell__auto-process">
          <eventq-boolean-toggle
            label="Auto-Process"
            variant="amber-dark"
            [checked]="autoProcess()"
            (checkedChange)="onAutoProcessToggleChange($event)"
          />
        </div>
      }
      <div class="agent-shell__user">
        <eventq-user-bar [email]="email()" (logout)="onLogout()" />
      </div>
    }
  </header>
  <main class="agent-shell__main" [attr.inert]="browserTabs.claimInteractionLocked() ? '' : null">
    @if (workspaceVisible()) {
      <router-outlet />
    } @else if (workspaceInitFailed()) {
      <p class="agent-shell__workspace-status" role="alert">
        Couldn't load your workspace. Refresh to try again.
      </p>
    } @else {
      <eventq-action-loader fill="panel" message="Loading Workspace" />
    }
  </main>
  <eventq-toast-container />
  @if (autoProcessConfirm(); as confirmMode) {
    <eventq-auto-process-popover
      [open]="true"
      [mode]="confirmMode"
      [submitDisabled]="false"
      (closed)="onAutoProcessConfirmClose()"
      (confirm)="onAutoProcessConfirm($event.enabled)"
    />
  }
</div>
